module.exports = __webpack_public_path__ + "img/Current_Monthly_Consumption_Value.cd58ee26.jpg";